import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const makeRevenueVoid = ({ churchId, revenueId, voidData }) => {
  return axios.post(
    `/churches/${churchId}/revenue/${revenueId}/void?_method=PATCH`,
    voidData
  );
};

export const useMakeRevenueVoid = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("revenues");
      queryClient.invalidateQueries("revenue");

      setNotification({
        type: "success",
        message: "Revenue voided successfully!"
      });
    },
    ...config,
    mutationFn: makeRevenueVoid
  });
};
